module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toch"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/edpreface"
    }
  }, [_vm._v("EDITORIAL PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0001"
    }
  }, [_vm._v("CHAPTER 1 - RAPE OF THE BUBBLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0002"
    }
  }, [_vm._v("CHAPTER 2 - FAITH AND SPIRIT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003"
    }
  }, [_vm._v("CHAPTER 3 - HARD CHOICE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004"
    }
  }, [_vm._v("CHAPTER 4 - FLIGHT INTO VACUUM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5 - FIGHT FOR LIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6 - BUBBLE, BUBBLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7 - BETRAYAL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8 - ADJUSTMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9 - MASSACRE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10 - TO LOVE AND BE LOVED")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11 - SACRIFICE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12 - FOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13 - REFUGEES’ WELCOME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14 - HELL PLANET")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15 - WHEN WILL IT END?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16 - VIOLATION OF TRUST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17 - FEMALE MYSTIQUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18 - PIRATE TREASURE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19 - THE FINAL RAID")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20 - SALVATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/edepilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EDITORIAL EPILOG")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Preview",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PREVIEW: "), _c('i', [_vm._v("MERCENARY")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 69
// module chunks = 0